export default __webpack_public_path__ + "images/sweep6.ffdffa75b0e11cb8064fcd4809dfd448.gif";